import { Box, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

interface Particle {
  id: number;
  left: number;
  color: string;
  delay: number;
  duration: number;
  size: number;
}

/**
 * CSS-only confetti animation effect
 * Creates falling particles for success celebration
 */
export const ConfettiEffect = () => {
  const theme = useTheme();
  const [particles, setParticles] = useState<Particle[]>([]);

  useEffect(() => {
    // Use branding primary color with other celebration colors
    const colors = [
      theme.palette.primary.main,
      theme.palette.primary.light,
      "#FF6B4A",
      "#FFD700",
      "#FF69B4",
    ];
    const particleCount = 50;

    const newParticles: Particle[] = Array.from(
      { length: particleCount },
      (_, i) => ({
        id: i,
        left: Math.random() * 100,
        color: colors[Math.floor(Math.random() * colors.length)],
        delay: Math.random() * 0.5,
        duration: 2 + Math.random() * 1,
        size: 8 + Math.random() * 8,
      }),
    );

    setParticles(newParticles);
  }, [theme.palette.primary.main, theme.palette.primary.light]);

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        pointerEvents: "none",
        zIndex: 9999,
        overflow: "hidden",
      }}
    >
      {particles.map((particle) => (
        <Box
          key={particle.id}
          sx={{
            position: "absolute",
            left: `${particle.left}%`,
            top: "-20px",
            width: `${particle.size}px`,
            height: `${particle.size}px`,
            backgroundColor: particle.color,
            borderRadius: "50%",
            animation: `fall ${particle.duration}s linear ${particle.delay}s 1`,
            animationFillMode: "forwards",
            opacity: 0.8,
            "@keyframes fall": {
              "0%": {
                transform: "translateY(0) rotate(0deg)",
                opacity: 1,
              },
              "100%": {
                transform: "translateY(100vh) rotate(360deg)",
                opacity: 0,
              },
            },
          }}
        />
      ))}
    </Box>
  );
};
